import React from "react";
import './styles.css';
import Header from './components/Header';
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Projects from "./components/Projects"

function App() {
  return (
    <div className="App">
     <Header />
     <main>
      <About />
      <Projects />
      <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
